module.exports = __webpack_public_path__ + "img/logo.1d8e8b6b.svg";